import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft, FaGlobe } from "react-icons/fa";
import { useLanguage } from "../../components/LanguageContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Language } from "../../Types/types";
import { AppDispatch } from "../../components/Manual_List/fetch/store";
import { postSubCategory } from "../../components/Manual_List/fetch/slices";
import PackageListHeader from "../../components/Headers/PackageListHeader";
import { AddLanguageModal } from "../../components/shared/AddLanguageModal";
import addsubcategorytranslation from "./SubcategoriesTrans";

const CreateSubcategory: React.FC = () => {
  const { language } = useLanguage();
  const t = addsubcategorytranslation[language as Language];
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const { subcategories, categoryId } = state || {};
  const [names, setNames] = useState<Record<string, string>>({});
  const [isNameModalOpen, setIsNameModalOpen] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const subcategoryData = {
      categoryId: categoryId,
      name: names,
    };

    const resultAction = await dispatch(postSubCategory(subcategoryData));

    if (postSubCategory.fulfilled.match(resultAction)) {
      toast.success(t.subcategorySuccess);
      navigate("/subcategories-list", {
        state: { refetch: true, id: categoryId, subcategories },
      });
    }
  };

  const handleNavigateBack = () => {
    navigate("/subcategories-list", {
      state: { refetch: true, id: categoryId, subcategories },
    });
  };

  return (
    <div className="min-h-screen w-screen flex flex-col bg-gray-100 dark:bg-darkBackground dark:text-white">
      <ToastContainer />
      <PackageListHeader />
      <div className="flex flex-col items-center justify-start flex-grow">
        <form
          id="create-subcategory-form"
          className="w-full px-4 sm:px-6 md:px-8 py-6 max-w-9xl flex flex-col relative"
          onSubmit={handleSubmit}
        >
          <div className="flex items-center mb-2">
            <FaArrowLeft
              className="text-gray-600 cursor-pointer mr-2"
              onClick={handleNavigateBack}
            />
            <h1 className="text-xl font-semibold">{t.title}</h1>
          </div>

          <div className="mb-2 relative">
            <label
              htmlFor="name"
              className="block mb-1 text-base font-thin ml-2"
            >
              {t.name}
            </label>
            <div className="relative">
              <input
                type="text"
                id="name"
                className="w-full pl-3 pr-3 py-2 rounded-md border border-gray-300 shadow-sm focus:outline-none focus:ring-0 dark:bg-darkBackground dark:border-purple"
                value={names[language] || ""}
                onChange={(e) =>
                  setNames({ ...names, [language]: e.target.value })
                }
                onClick={() => setIsNameModalOpen(true)}
                autoComplete="off"
              />
              <FaGlobe className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>
          <div className="absolute bottom-0 -mb-4 right-8 flex space-x-2">
            <button
              type="button"
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded font-medium shadow-sm dark:bg-white dark:text-black"
              onClick={handleNavigateBack}
            >
              {t.discard}
            </button>
            <button
              type="submit"
              className="bg-purple text-white px-4 py-2 rounded font-medium shadow-sm"
              form="create-subcategory-form"
            >
              {t.save}
            </button>
          </div>
        </form>
      </div>
      <AddLanguageModal
        isOpen={isNameModalOpen}
        onClose={() => setIsNameModalOpen(false)}
        translations={t}
        mode="name"
        values={names}
        setValues={setNames}
      />
    </div>
  );
};

export default CreateSubcategory;
